import player from '../../components/youtubeVideoPlayer.js';
document.querySelectorAll('[data-video-player]').forEach(
  playerContainer => new player(playerContainer));
